import { formatAdminCount } from "../formatting/format-admin-count";
import { pickAdminDashboardLocaleText } from "./admin-dashboard-copy";
import type { AdminDashboardLocale } from "./admin-dashboard-locale";

export type AdminAccountDeletionSeveritySummaryViewModel = {
  detail: string;
  drilldownTo: string;
  headline: string;
  label: string;
};

export type AdminAccountDeletionSeveritySummaryInput = {
  failedCount: number;
  processingCount: number;
  queuedCount: number;
  succeededCount: number;
};

export function buildAdminAccountDeletionSeveritySummary(
  input: AdminAccountDeletionSeveritySummaryInput,
  drilldownTo: string,
  locale: AdminDashboardLocale,
): AdminAccountDeletionSeveritySummaryViewModel {
  const failedCountLabel = formatAdminCount(input.failedCount);
  const processingCountLabel = formatAdminCount(input.processingCount);
  const queuedCountLabel = formatAdminCount(input.queuedCount);
  const succeededCountLabel = formatAdminCount(input.succeededCount);

  let headline: string;
  if (input.failedCount > 0) {
    headline = pickAdminDashboardLocaleText(locale, { en: "Deletion failed", ko: "삭제 실패" });
  } else if (input.processingCount > 0 || input.queuedCount > 0) {
    headline = pickAdminDashboardLocaleText(locale, { en: "Deletion backlog", ko: "삭제 대기" });
  } else {
    headline = pickAdminDashboardLocaleText(locale, { en: "No deletion backlog", ko: "삭제 대기 없음" });
  }

  const detail = locale === "en"
    ? `account deletion currently has ${failedCountLabel} failed, ${processingCountLabel} processing, and ${queuedCountLabel} queued jobs while ${succeededCountLabel} already succeeded.`
    : `계정 삭제 작업은 현재 실패 ${failedCountLabel}건, 처리 중 ${processingCountLabel}건, 대기 ${queuedCountLabel}건이며 이미 ${succeededCountLabel}건이 성공했습니다.`;

  return {
    label: pickAdminDashboardLocaleText(locale, { en: "Account deletion", ko: "계정 삭제" }),
    headline,
    detail,
    drilldownTo,
  };
}
